import { useQuery } from 'hooks/useCustomQuery';

import { useDispatch } from 'react-redux';

async function getPublicPartnerData() {
    const host = window.location.host.startsWith('127.0.0.1')
        ? 'teamsdev.tcap.dev'
        : window.location.host;

    const res = await fetch(
        `${import.meta.env.VITE_APP_API_URL}/theme/${host}`,
        {
            headers: {
                'x-RequestScope': '20',
            },
        },
    );

    if (!res.ok) {
        throw new Error('Could not fetch public partner data');
    }

    return await res.json();
}

function useGetPublicPartnerData() {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ['publicPartnerData'],
        queryFn: getPublicPartnerData,
        staleTime: 0,
        cacheTime: 0,
        onSuccess: (data) => {
            dispatch({
                type: 'SET_SBC_DOMAIN',
                payload: data.sbcDomain,
            });
            dispatch({
                type: 'CHANGE_IMAGE_PATH_LIGHT_MODE',
                payload: data.lightLogo,
            });
            dispatch({
                type: 'CHANGE_IMAGE_PATH_DARK_MODE',
                payload: data.darkLogo,
            });

            dispatch({
                type: 'HEADER_FAVICON_SUCCESS',
                payload: data.favicon,
            });
            dispatch({
                type: 'HEADER_TITLE_SUCCESS',
                payload: data.titleName,
            });
            dispatch({
                type: 'SET_SUPPORT_URL',
                payload: data.extLinkSupport,
            });
        },
    });
}

export { useGetPublicPartnerData };
